import moment from 'moment';
import CustomImage from '../../../../../../v2-components/Antd/Image';

export const renderRejectionHistory = (rejectionHistory) => {
	return rejectionHistory.map((item, index) => (
		<div key={index}>
			<p>Fecha: {moment(item?.date).format('DD/MM/YYYY HH:mm:ss')}</p>
			<p>Responsable: {item.signature}</p>
			<p>Motivo de rechazo: {item.reason}</p>
			<p>Mensaje interno: {item.description}</p>
			<p>
				Receta: <CustomImage src={item.recipe} width={100} />
			</p>
			<span>--------------------------------------------------------------------</span>
		</div>
	));
};
